import React from 'react';
import ShareTab from '../ShareTabs/ShareTab';
export default function CollaboratorsTabs({ activeTab, onClick, tabNames }) {
    return tabNames.map((name) => {
        return (React.createElement(ShareTab, { isActive: activeTab === name, key: name, name: name, onClick: () => onClick(name) }, name));
    });
}
